import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const FILTER_KEY = 'quick_filter_brandSearch';

export const useQuickFilterSectionBrandSearchOpenedState = () => {
  return useOpenedStateManager(FILTER_KEY);
};
